<template>
  <v-row v-if="projectDetails" dense>
    <v-col cols="12" >
      <domain-image position="center" v-if="isMobile" height="70" transparent class="mb-5"></domain-image>
      <v-row v-if="isMobile" justify="center">
        <!-- <big-round-button color="success" class=" mb-3 mr-3" icon="mdi-lifebuoy" text="ΟΔΗΓΙΕΣ ΑΠΕΓΚΛ"
                           :to="'/lift/'+projectDetails.Project_ID+'/apeglovismos'"></big-round-button> -->
        <callout-button class="mb-2 mr-2" is-modal
                        v-if="userDetails.Allows.AddCallouts"
                        :project_id="projectDetails.Project_ID"
                        :branch_id="projectDetails.Branch_ID"
                        :partner_id="projectDetails.Partner_ID"
        >
        </callout-button>
        <big-round-button color="primary" class="mr-3 mb-3" icon="mdi-wrench" text="ΣΥΝΤΗΡ."
                          :to="'/lift/'+projectDetails.Project_ID+'/maintenances'"></big-round-button>

        <big-round-button v-if="userDetails.Allows.ShowCallouts" color="primary" class="mr-3 mb-2" icon="mdi-alert-outline" text="ΒΛΑΒΕΣ"
                          :to="'/lift/'+projectDetails.Project_ID+'/callouts'"></big-round-button>

        <big-round-button color="primary" v-if="userDetails.Allows.ShowCallouts && userDetails.Allows.ShowMaintenances" class=" mb-3 mr-3" icon="mdi-history" text="ΙΣΤΟΡΙΚΟ"
                          :to="'/lift/'+projectDetails.Project_ID+'/history'"></big-round-button>

        <big-round-button color="primary" class="mr-3 mb-2" icon="mdi-clock-outline" text="ΠΕΡΙΟΔΙΚΕΣ ΕΡΓΑΣΙΕΣ"
                          :to="'/lift/'+projectDetails.Project_ID+'/periodic'"></big-round-button>

        <big-round-button color="primary" class=" mb-3 mr-3" icon="mdi-domain"
                          v-if="!userDetails.AltTiSi.IsProjectFromQRCode"
                          text="ΚΤΗΡΙΟ"
                          :to="'/building/'+projectDetails.Branch_ID"></big-round-button>


      </v-row>
      <!--<big-round-button color="primary" class="mr-2 mb-2" icon="mdi-file" text="ΑΡΧΕΙΑ"  ></big-round-button>-->

    </v-col>
    <v-col cols="12">
      <v-card>
        <v-card-title>
          Συντήρηση
        </v-card-title>

        <v-row>
          <v-col>
            <v-list-item >
              <v-list-item-action>
                <v-icon color="primary">mdi-check-circle</v-icon>
              </v-list-item-action>
              <v-list-item-content>
                <v-list-item-title>{{ projectDetails.LastSint | fullDate }}</v-list-item-title>
                <v-list-item-subtitle> Τελευταία συντήρηση</v-list-item-subtitle>
              </v-list-item-content>
            </v-list-item>
          </v-col>
          <v-col>
            <v-list-item>
              <v-list-item-action>
                <v-icon>mdi-circle</v-icon>
              </v-list-item-action>
              <v-list-item-content>
                <v-list-item-title>{{ projectDetails.EktHmerSint | fullDate }}</v-list-item-title>
                <v-list-item-subtitle> Επόμενη συντήρηση (εκτίμιση)</v-list-item-subtitle>
              </v-list-item-content>
            </v-list-item>
          </v-col>
        </v-row>
        <v-card-text>
          Συχνότητα συντήρησης
          <v-simple-table dense>
            <template v-slot:default>
              <thead>
              <tr>
                <th class="text-left">1</th>
                <th class="text-left">2</th>
                <th class="text-left">3</th>
                <th class="text-left">4</th>
                <th class="text-left">5</th>
                <th class="text-left">6</th>
                <th class="text-left">7</th>
                <th class="text-left">8</th>
                <th class="text-left">9</th>
                <th class="text-left">10</th>
                <th class="text-left">11</th>
                <th class="text-left">12</th>
              </tr>
              </thead>
              <tbody>
              <tr>
                <td v-for="month in projectDetails.SixnotitaSintirisis">
                  <v-icon small v-if="month">mdi-check-circle</v-icon>
                </td>
              </tr>
              </tbody>
            </template>
          </v-simple-table>
        </v-card-text>
      </v-card>
    </v-col>
    <v-col cols="12">
      <v-card>
        <v-card-title> Τεχνικά Χαρακτηριστικά</v-card-title>
        <v-card-text>
          <v-data-iterator
              :group-by="['SpecDescr']"
              :items="projectDetails.Specifications"
              hide-default-footer
              disable-pagination
              no-data-text="Δεν υπάρχουν τεχνικά χαρακτηριστικά διαθέσιμα"
          >
            <template v-slot:default="props">
              <template>
                <v-expansion-panels flat multiple>
                  <v-expansion-panel v-for="group in props.groupedItems">
                    <v-expansion-panel-header class="pa-0 grey lighten-3">
                      <v-list-item dense>
                        <v-list-item-content>
                          <v-list-item-title class="text--black">
                            {{ group.name }}
                          </v-list-item-title>
                        </v-list-item-content>
                      </v-list-item>
                    </v-expansion-panel-header>
                    <v-expansion-panel-content eager>
                      <v-list>
                        <v-list-item class="pa-0" v-for="item in group.items">
                          <v-list-item-content>
                            <v-list-item-title> {{ item.SpecItemValue }}</v-list-item-title>
                            <v-list-item-subtitle> {{ item.SpecItemDescr }}</v-list-item-subtitle>
                          </v-list-item-content>
                        </v-list-item>
                      </v-list>
                    </v-expansion-panel-content>
                  </v-expansion-panel>
                </v-expansion-panels>

              </template>

            </template>
          </v-data-iterator>
        </v-card-text>
      </v-card>

    </v-col>
  </v-row>
</template>

<script>
import {mapActions, mapGetters} from "vuex";
import EventCard from "../../Events/components/EventCard";
import EventMobileItem from "@/views/Events/components/EventMobileItem";
import BigRoundButton from "@/components/BigRoundButton";
import CalloutButton from "@/views/Events/components/CalloutButton";
import DomainImage from "@/components/DomainImage";

export default {
  name: "ProjectCard",
  components: {DomainImage, CalloutButton, BigRoundButton, EventMobileItem, EventCard},
  data: () => ({
    dialog: false,
    activeEvent: null,
    headers: [
      {
        text: 'Hμ/νια ',
        value: 'DateEventInsert',
        filterable: true,
        width: "100"
      },
      {
        text: 'Tύπος',
        value: 'EventType_ID',
        filterable: true,
        width: "100"
      },
      {
        text: 'Περιγραφή',
        value: 'Description',
        filterable: true,
      },
    ]
  }),

  computed: {
    ...mapGetters([
      "isMobile",
      "userDetails"
    ]),
    ...mapGetters('project', [
      "projectDetails",
      "projectEvents",
    ]),

  },

  methods: {
    ...mapActions('project', [
      "getProjectEvents"
    ]),
    created() {
    },
    rowClick(event) {
      if (!this.isMobile) {
        this.$modal.show(EventCard, {eventId: event.Event_ID}, {height: 'auto', width: '70%'});
      } else {
        this.dialog = true;
        this.activeEvent = event
      }
    },
    onTabChange(tabIndex) {
      if (tabIndex === 1) {
        this.getProjectEvents();
      }
    }
  }
}
</script>

<style scoped>
td {
  padding: 0 5px 0 5px !important;
}

th {
  padding: 0 5px 0 5px !important;
}
</style>
